import "./dashboard.css"
import { useState, useEffect } from "react"
import { getUserOverview } from "./api.services"
import { UserOverview } from "./dashboard.type"
import UserPlan from "./molecules/UserPlan"
import TotalSpaceUsage from "./molecules/TotalSpaceUsage"
import { OrganizationDetailCard } from "./molecules/OrganizationDetailCard"
import { useAppSelector } from "hooks/useApp"

const Dashboard = () => {
  const userInfo = useAppSelector((state) => state.userInfo)
  const organizationId = userInfo.last_organization_id
  const [data, setData] = useState<UserOverview>({
    tier: "Free user",
    limited_size: "0 GB",
    used_size: "0 GB",
    used_percentage: 0,
    project_count: 0,
    quota_limit: 0,
    quota_number: 0,
    renew_at: "N/A",
    description: "N/A",
    download_histories: [],
    project_limit: 0,
    component_per_project_limit: 0,
    live_project_count: 0,
  })

  const getDashboardOverview = () => {
    getUserOverview().then((response) => setData(response))
  }

  useEffect(() => {
    if (!organizationId) {
      return
    }
    getDashboardOverview()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationId])

  if (!organizationId) {
    return <div></div>
  }

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <div className="flex flex-col py-6 pl-6 flex-1 overflow-hidden">
        <div className="flex flex-col lg:flex-row pr-6 overflow-auto gap-6">
          <div className="flex-1">
            <OrganizationDetailCard organizationId={organizationId || ""} />
          </div>
          <div className="flex flex-col sm:flex-row gap-6">
            <UserPlan data={data} />
            <TotalSpaceUsage data={data} />
          </div>
        </div>
      </div>
    </div>
  )
}
export default Dashboard
